import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

const spinnerStyle = {
  border: "10px solid #f3f3f3",
  borderTop: "10px solid #3498db",
  borderRadius: "50%",
  width: "70px",
  height: "70px",
  animation: "spin 1s linear infinite",

};

const spinnerContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  zIndex: 9999,
  backgroundColor: "white"
};

const SpinnerStyle = () => (
  <style>
    {`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}
  </style>
);

const PublicRoute = ({ restricted, element: Component }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <>
        <SpinnerStyle />
        <div style={spinnerContainerStyle}>
          <div style={spinnerStyle}></div>
        </div>
      </>
    );
  }

  return isAuthenticated && restricted ? (
    <Navigate to="/shifts" replace />
  ) : (
    Component
  );
};

export default PublicRoute;
